import React from 'react';

const UnauthorizedLayout = ({ children }: { children: React.ReactNode }) => {
    return <div>{children}</div>;
};

export default UnauthorizedLayout;
